module.exports = __webpack_public_path__ + "a37c0d92aebd437f6d2968869fc79878.webp";